export const getAllItems = (state: App.State) =>
  state.cart.offers.reduce<Array<App.CartItem>>((allItems, offer) => [...allItems, ...offer.items], []);

export const getAllAddons = (state: App.State) =>
  state.cart.offers.reduce<Array<App.CartAddon>>((allAddons, offer) => [...allAddons, ...offer.addons], []);
